module.exports = __webpack_public_path__ + "static/media/reg_um.a842cca0.png";